/** Business status for visitor master tables (`status_id` → `mst_statuses`). */
export const VISITOR_MASTER_STATUS_OPTIONS = [
  { value: "1", label: "Active" },
  { value: "2", label: "Inactive" },
];

export function isVisitorMasterStatusActive(row) {
  if (!row) return false;
  const status = row.status_id != null && row.status_id !== "" ? Number(row.status_id) : 1;
  return status === 1;
}
